<!-- TimelineHeader.vue
  各教室の表札
 -->
<template lang="html">
  <th class="tlHeader" :style="getStyle">
    <span class="tlHeaderText">{{ classroom }}</span>
  </th>
</template>

<script>
import {
  UPDATE_HEADER_HEIGHT
} from '@/vuex/mutation_types'
export default {
  name: 'tl-header',
  props: [
    'classroom' // 教室名
  ],
  computed: {
    getStyle () {
      let style = {
        width: this.$store.state.columnWidth + 'px',
        height: this.$store.state.tbHeaderHeight + 'px',
        'border-top-style': 'none',
        'border-top-width': '0px'
      }
      return style
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$store.commit(UPDATE_HEADER_HEIGHT, this.$el.getBoundingClientRect().height)
    })
  }
}
</script>

<style lang="css" scoped>
.tlHeader {
  box-sizing: border-box;
  text-align: center;
  letter-spacing: normal;

  border-bottom-style: solid;
  border-bottom-width: 2px;
  border-bottom-color: black;

  border-left-style: solid;
  border-left-width: 1px;
  border-left-color: #aaaaaa;
  border-right-style: solid;
  border-right-width: 1px;
  border-right-color: #aaaaaa;

  background-color: white;
}
.tlHeaderText {
  margin: auto;
  white-space: pre;
}
</style>



// WEBPACK FOOTER //
// TimelineHeader.vue?416d28e0